"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidFormulaError = void 0;
class InvalidFormulaError extends Error {
    constructor(message, exp) {
        super(message);
        this.name = "Invalid formula";
        this.data = { exp };
    }
    getData() {
        return this.data;
    }
}
exports.InvalidFormulaError = InvalidFormulaError;
